import { render, staticRenderFns } from "./CreateModuleWindow.vue?vue&type=template&id=307ce3ce"
import script from "./CreateModuleWindow.vue?vue&type=script&lang=js"
export * from "./CreateModuleWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports